import { createApp } from "vue";
import i18n from '../translations/i18n';
import CheckoutDeliveryEstimate from "../../components/CheckoutDeliveryEstimate";
import CheckoutPaymentStep from "../../components/Checkout/CheckoutPaymentStep";
import CheckoutPhoneNumberRequiredModal from "../../components/Checkout/CheckoutPhoneNumberRequiredModal";
import CheckoutPayment from "../../components/CheckoutPayment";
import CheckoutProgress from "../../components/CheckoutProgress";
import AddressEditPage from "../../components/AddressEditPage";
import AddressCreatePage from "../../components/AddressCreatePage";
import GuestToCustomerModal from "../../components/GuestToCustomerModal";
import ModalVue from "../../components/ModalVue";
import EmailInput from "../../components/EmailInput.vue";

export const initializeCheckoutCartApp = () => {
    if (!document.getElementById('js_CheckoutCart')) {
        return;
    }

    const app = createApp({});

    app.use(i18n);

    app.component('checkout-delivery-estimate', CheckoutDeliveryEstimate);

    app.mount('#js_CheckoutCart');
};

export const initializeCheckoutPaymentApp = () => {
    if (!document.getElementById('js_CheckoutPaymentStep')) {
        return;
    }

    const app = createApp({});

    app.use(i18n);

    app.component('checkout-payment-step', CheckoutPaymentStep);

    app.mount('#js_CheckoutPaymentStep');
};

export const initializeCheckoutApp = () => {
    if (!document.getElementById('js_checkout')) {
        return;
    }

    const app = createApp({});

    app.use(i18n);

    app.component('checkout-payment', CheckoutPayment);
    app.component('checkout-progress', CheckoutProgress);
    app.component('checkout-phone-number-required-modal', CheckoutPhoneNumberRequiredModal);

    app.mount('#js_checkout');
};

export const initializeContactApp = () => {
    if (!document.getElementById('js_contact')) {
        return;
    }

    const app = createApp({});

    app.use(i18n);

    app.component('email-input', EmailInput);

    app.mount('#js_contact');
};

export const initializeAddressApp = () => {
    if (!document.getElementById('js_address')) {
        return;
    }

    const app = createApp({});

    app.use(i18n);

    app.component('address-edit-page', AddressEditPage);
    app.component('address-create-page', AddressCreatePage);

    app.mount('#js_address');
};

export const initializeOrderConfirmationApp = () => {
    if (!document.getElementById('js_orderconfirmation')) {
        return;
    }

    const app = createApp({});

    app.use(i18n);

    app.component('modal-vue', ModalVue);
    app.component('guest-to-customer-modal', GuestToCustomerModal);

    app.mount('#js_orderconfirmation');
};
